import { Box, Text, useColorModeValue, VStack } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { SettlementExecutionTrigger } from './SettlementExecutionTrigger'

export function ExecuteSettlementTab() {
  const { t } = useTranslation()
  const textColor = useColorModeValue('gray.600', 'gray.300')

  return (
    <VStack align="stretch" spacing={4}>
      <Text fontSize="sm" color={textColor}>
        {t('settlements.execute.subtitle')}
      </Text>
      <Box>
        <SettlementExecutionTrigger />
      </Box>
    </VStack>
  )
}
